import { render, staticRenderFns } from "./remark-table.vue?vue&type=template&id=1f0136bd&"
import script from "./remark-table.vue?vue&type=script&lang=js&"
export * from "./remark-table.vue?vue&type=script&lang=js&"
import style0 from "./remark-table.vue?vue&type=style&index=0&id=1f0136bd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports